/* eslint-disable no-restricted-syntax */
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.contact-accordion',
        item: '.contact-accordion__item',
        description: '.contact-accordion__description',
        content: '.contact-accordion__content',
        cta: '.contact-accordion__cta',
        edit: '.contact-accordion__edit',
        textInput: '.text-input__input-field',
        charactersLeft: '.text-input__characters-left',
        radioButtons: '.radio-buttons__default-input',
        privacyPolicy: '.detail-form__privacypolicy-input',
        inputSummary: '.contact-accordion__input-summary',
        errorMessage: '.contact-accordion__error-message',
        altErrorMessage: '.contact-accordion__alt-error-message',
        detailForm: '.detail-form__inner',
        titles: '.detail-form__titles',
        titleInput: '.detail-form__title-input',
    },
    classNames: {
        accordionItemExpanded: 'contact-accordion__item--expanded',
        accordionItemCollapsed: 'contact-accordion__item--collapsed',
        accordionItemFinished: 'contact-accordion__item--finished',
        accordionFinished: 'contact-accordion--finished',
        accordionCtaDisabled: 'contact-accordion__cta--disabled',
        accordionError: 'contact-accordion__error-message--visible',
        accordionAltError: 'contact-accordion__alt-error-message--visible',
        textareaAlmostFull: 'text-input__characters--red',
        detailFormError: 'detail-form--error',
        detailFormErrorMessage: 'detail-form__message',
        detailFormShowErrorMessage: 'detail-form__message--error',
        customselect: 'detail-form__custom-select',
        selectSelected: 'detail-form__select-selected',
        selectSelectedActive: 'detail-form__select-selected--active',
        selectItems: 'detail-form__select-items',
        selectItemsHide: 'detail-form__select-hide',
        selectItem: 'detail-form__select-item',
        sameAsSelected: 'detail-form__same-as-selected',
        customTitle: 'detail-form__title-input--custom-title',
        privacyPolicy: 'detail-form__privacypolicy',
    },
    dataAttributes: {
        index: 'index',
    },
};

class ContentAccordion {

    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._index = 0;
        this._maxlength = 500;
        this._altError = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
       
        this._expandItem(this._index);
        this._elements.$textInput[0].value = '';
        this._elements.$radioButtons.prop('checked', false);
        this._elements.$privacyPolicy.prop('checked', false);
        for (let item of this._elements.$detailForm[0].children) {
            item.value = '';
        }
        // for (let item of this._elements.$radioButtons) {
        //     console.log(item);
        // }
    }

    _getDomElements() {
        return {
            $content: this._$rootElement.find(config.selectors.content),
            $description: this._$rootElement.find(config.selectors.description),
            $item: this._$rootElement.find(config.selectors.item),
            $cta: this._$rootElement.find(config.selectors.cta),
            $edit: this._$rootElement.find(config.selectors.edit),
            $textInput: this._$rootElement.find(config.selectors.textInput),
            $charactersLeft: this._$rootElement.find(config.selectors.charactersLeft),
            $radioButtons: this._$rootElement.find(config.selectors.radioButtons),
            $privacyPolicy: this._$rootElement.find(config.selectors.privacyPolicy),
            $inputSummary: this._$rootElement.find(config.selectors.inputSummary),
            $errorMessage: this._$rootElement.find(config.selectors.errorMessage),
            $altErrorMessage: this._$rootElement.find(config.selectors.altErrorMessage),
            $detailForm: this._$rootElement.find(config.selectors.detailForm),
            $titles: this._$rootElement.find(config.selectors.titles),
            $titleInput: this._$rootElement.find(config.selectors.titleInput),
        };
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$cta.on('click', function () {
            const index = $(this).data(config.dataAttributes.index);

            if (_this._validateInput()) {
                if (index === _this._elements.$item.length - 1) {
                    const $accordion = _this._$rootElement;
                    $accordion.addClass(config.classNames.accordionFinished);
                    return;
                }
                $(_this._elements.$errorMessage[_this._index]).removeClass(config.classNames.accordionError);
                $(_this._elements.$altErrorMessage[_this._index]).removeClass(config.classNames.accordionAltError);
                _this._finishItem(index);
                _this._expandItem(index + 1);
            } else if (_this._altError) {
                $(_this._elements.$errorMessage[_this._index]).removeClass(config.classNames.accordionError);
                $(_this._elements.$altErrorMessage[_this._index]).addClass(config.classNames.accordionAltError);
            } else {
                $(_this._elements.$altErrorMessage[_this._index]).removeClass(config.classNames.accordionAltError);
                $(_this._elements.$errorMessage[_this._index]).addClass(config.classNames.accordionError);
            }
        });

        this._elements.$edit.on('click', function () {
            const newIndex = $(this).data(config.dataAttributes.index);
            if (_this._validateInput() || _this._index > newIndex) {
                $(_this._elements.$errorMessage[_this._index]).removeClass(config.classNames.accordionError);
                $(_this._elements.$altErrorMessage[_this._index]).removeClass(config.classNames.accordionAltError);
                _this._finishItem(_this._index);
                _this._expandItem(newIndex);
            } else if (_this._altError) {
                $(_this._elements.$errorMessage[_this._index]).removeClass(config.classNames.accordionError);
                $(_this._elements.$altErrorMessage[_this._index]).addClass(config.classNames.accordionAltError);
            } else {
                $(_this._elements.$altErrorMessage[_this._index]).removeClass(config.classNames.accordionAltError);
                $(_this._elements.$errorMessage[_this._index]).addClass(config.classNames.accordionError);
            }
        });

        this._elements.$textInput.on('input', function () {
            _this._elements.$inputSummary[_this._index].innerText = $(this).val();
            const currentLength = $(this).val().length;
            const charsLeft = _this._maxlength - currentLength;
            const $charactersLeft = _this._elements.$charactersLeft;
            $($charactersLeft).html(charsLeft + '/' + _this._maxlength);
            if (charsLeft < 20) {
                if (!$charactersLeft.hasClass(config.classNames.textareaAlmostFull)) {
                    $charactersLeft.addClass(config.classNames.textareaAlmostFull);
                }
            } else {
                $charactersLeft.removeClass(config.classNames.textareaAlmostFull);
            }
            if (currentLength === 0) {
                $(_this._elements.$cta[_this._index]).addClass(config.classNames.accordionCtaDisabled);
            } else {
                $(_this._elements.$cta[_this._index]).removeClass(config.classNames.accordionCtaDisabled);
            }
        });

        this._elements.$radioButtons.on('change', function () {
            _this._elements.$inputSummary[_this._index].innerText = this.value;
            $(_this._elements.$cta[_this._index]).removeClass(config.classNames.accordionCtaDisabled);
        });

        this._elements.$privacyPolicy.on('change', function () {
            if (this.checked) {
                $(_this._elements.$cta[_this._index]).removeClass(config.classNames.accordionCtaDisabled);
            } else {
                $(_this._elements.$cta[_this._index]).addClass(config.classNames.accordionCtaDisabled);
            }
        });
    }

    _expandItem(index) {
        const $el = $(this._elements.$content[index]);
        $el.height(`${$el[0].scrollHeight + 15}px `);
        const $description = $(this._elements.$description[index]);
        $description.height($description[0].scrollHeight);
        const $item = $(this._elements.$item[index]);
        $item.addClass(config.classNames.accordionItemExpanded);
        $item.removeClass(config.classNames.accordionItemCollapsed);
        this._index = index;
    }

    _collapseItem(index) {
        const $el = $(this._elements.$content[index]);
        $el.height(0);
        const $description = $(this._elements.$description[index]);
        $description.height(0);
        const $item = $(this._elements.$item[index]);
        $item.removeClass(config.classNames.accordionItemFinished);
        $item.removeClass(config.classNames.accordionItemExpanded);
        $item.addClass(config.classNames.accordionItemCollapsed);
    }

    _finishItem(index) {
        this._collapseItem(index);
        const $item = $(this._elements.$item[index]);
        $item.removeClass(config.classNames.accordionItemExpanded);
        $item.removeClass(config.classNames.accordionItemCollapsed);
        $item.addClass(config.classNames.accordionItemFinished);
    }

    _validateInput() {
        this._altError = false;
        let valid = true;
        let emptyInputField = true;
        let detailError = false;
        const inputLength = this._elements.$textInput.val().length;
        switch (this._index) {
            case 0:
                return this._elements.$inputSummary[this._index].innerText.length > 0;
            case 1:
                if (inputLength >= this._maxlength) {
                    return false;
                } else if (inputLength === 0) {
                    this._altError = true;
                    return false;
                }
                return true;
            case 2:
                for (let item of this._elements.$detailForm[0].children) {
                    if ($(item).hasClass(config.classNames.detailFormErrorMessage)) {
                        if (detailError === true) {
                            $(item).addClass(config.classNames.detailFormShowErrorMessage);
                        } else {
                            $(item).removeClass(config.classNames.detailFormShowErrorMessage);
                        }
                    } else {
                        if ($(item).hasClass(config.classNames.customselect)) {
                            emptyInputField = ($(item).find('select').val() === null);
                        } else {
                            emptyInputField = (item.value === '');
                        }
                        if ((emptyInputField && !$(item).hasClass(config.classNames.privacyPolicy)
                            && $(item).css('display') !== 'none'
                            && item.type !== 'tel')
                            || (item.type === 'email'
                            && !item.validity.valid
                            )) {
                            $(item).addClass(config.classNames.detailFormError);
                            valid = false;
                            detailError = true;
                        } else {
                            $(item).removeClass(config.classNames.detailFormError);
                            detailError = false;
                        }
                    }
                    const $el = $(this._elements.$content[2]);
                    $el.height($el[0].scrollHeight);
                }
                return valid;
            default: return true;
        }
    }

   
}

moduleRegistry.registerModule('ContentAccordion', ContentAccordion);
moduleRegistry.autoApplyModule('ContentAccordion', config.selectors.root);
